// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*  ======================
    Component styles on page load
    ====================== */

.SelectionDropdown_mapFilterTrigger__\\+-qEB {
    float: left;
    width: 100%;
    display: inline-block;
    padding: 7.5px 10px;
    height: auto;
    line-height: 21px;
    font-size: 14px;
    color: var(--color-darkui-surface-1);
    background: var(--color-white);
    text-decoration: none;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15);
    border-radius: 4px;
    box-sizing: border-box;
}

.SelectionDropdown_mapFilterTrigger__\\+-qEB:disabled {
    cursor: default;
    background: var(--color-lightui-surface-3);
    color: var(--color-darkui-accent-2);
}

.SelectionDropdown_mapFilterLabel__LQbil {
    float: left;
    display: inline-block;
    max-width: 135px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.SelectionDropdown_mapFilter__iuSYe {
    width: auto;
    display: flex;
    flex-direction: column;
    container: mapFilter / inline-size;
    contain: layout;
}

.SelectionDropdown_mapFilterDetail__n5GVg {
    position: absolute;
    display: inline;
    top: 0%;
    z-index: -1;
    width: 100%;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), 0 1px 0 0 var(--color-103);
    border-radius: 4px;
    background: var(--color-white);
    height: 0;
    padding: 0 10px;
    overflow: hidden;
    font-size: 12px;
    transition: all 0.4s ease;
    box-sizing: border-box;
}

.SelectionDropdown_mapFilterDetail__n5GVg ul {
    margin-left: 5px;
    list-style-type: none;
    margin-bottom: 0;
}

.SelectionDropdown_mapFilterDetail__n5GVg li.SelectionDropdown_sectionDetails__Mm2fT {
    color: black;
    line-height: 22px;
    height: 22px;
}

.SelectionDropdown_mapFilterDetail__n5GVg ul.SelectionDropdown_sectionLabel__cDgLv {
    color: var(--color-darkui-accent-2);
}

.SelectionDropdown_mapFilterDetail__n5GVg li.SelectionDropdown_divider__4IOn- {
    margin: 6px 0;
    border: 0;
    background-color: var(--color-103);
    height: 1px;
    cursor: initial;
}

.SelectionDropdown_sectionItemLink__ad69K {
    color: var(--color-blue-primary);
}

.SelectionDropdown_filterCount__gAJKV {
    padding: 4px;
    color: var(--color-104);
    width: 12px;
    height: 12px;
    line-height: 12px;
    text-align: center;
    border-radius: 12px;
    display: inline-block;
    opacity: 1;
    transition: opacity 0.3s ease;
    background: var(--color-darkui-accent-2);
    font-size: 12px;
    float: right;
}

.SelectionDropdown_filterOnly__NCWKh {
    position: relative;
    top: -25px;
    float: right;
    display: none;
    height: 20px;
    color: var(--color-201);
    text-align: right;
    cursor: pointer;
    font-size: 12px;
    text-decoration: none;
    outline: none;
}

.SelectionDropdown_iconPointerDown__T56SO {
    float: left;
    margin-top: 3px;
    margin-right: 5px;
    font-size: 6px;
    color: var(--color-darkui-accent-2);
    transition: width 0.2s ease;
    display: inline-block;
    width: 6px;
    height: 6px;
    line-height: 14px;
    vertical-align: text-top;
    background-position: 14px 14px;
    background-repeat: no-repeat;
    font-family: "connect-icons";
    font-weight: normal;
    font-style: normal;
    font-variant: normal;
    speak: none;
    text-transform: none;
    text-rendering: auto;
}

.SelectionDropdown_iconPointerDown__T56SO:before {
    content: "\\25bc";
}

.SelectionDropdown_ellipsis__Npgwa{
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

input.SelectionDropdown_selectionInput__dh1JK {
    margin-right: 3px;
}

/*  ======================
    Component styles on hover, active, focus, etc.
    ====================== */

.SelectionDropdown_open__jJfAD .SelectionDropdown_mapFilterTrigger__\\+-qEB .SelectionDropdown_iconPointerDown__T56SO,
.SelectionDropdown_mapFilterTrigger__\\+-qEB:hover:enabled .SelectionDropdown_iconPointerDown__T56SO,
.SelectionDropdown_mapFilterTrigger__\\+-qEB:active:enabled .SelectionDropdown_iconPointerDown__T56SO {
    color: var(--color-102);
}

.SelectionDropdown_mapFilterTrigger__\\+-qEB:hover:enabled,
.SelectionDropdown_mapFilterTrigger__\\+-qEB:active:enabled,
.SelectionDropdown_open__jJfAD .SelectionDropdown_mapFilterTrigger__\\+-qEB {
    color: var(--color-101);
    text-decoration: none;
    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), 0 1px 0 0 var(--color-103);
}

.SelectionDropdown_mapFilterDetail__n5GVg li:hover .SelectionDropdown_filterOnly__NCWKh {
    display: inline;
}

.SelectionDropdown_sectionItemLink__ad69K:hover {
    color: var(--color-blue-primary);
    text-decoration: underline;
}

/*  ======================
    Component styles on state change
    ====================== */

.SelectionDropdown_open__jJfAD {
    height: auto;
    top: 100%;
}

.SelectionDropdown_open__jJfAD .SelectionDropdown_mapFilterDetail__n5GVg {
    padding: 10px;
}`, "",{"version":3,"sources":["webpack://./node_modules/ui-connect/Dropdown/SelectionDropdown.module.css"],"names":[],"mappings":"AAAA;;4BAE4B;;AAE5B;IACI,WAAW;IACX,WAAW;IACX,qBAAqB;IACrB,mBAAmB;IACnB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,oCAAoC;IACpC,8BAA8B;IAC9B,qBAAqB;IACrB,2CAA2C;IAC3C,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,0CAA0C;IAC1C,mCAAmC;AACvC;;AAEA;IACI,WAAW;IACX,qBAAqB;IACrB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,sBAAsB;IACtB,kCAAkC;IAClC,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,OAAO;IACP,WAAW;IACX,WAAW;IACX,uEAAuE;IACvE,kBAAkB;IAClB,8BAA8B;IAC9B,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,YAAY;AAChB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,kCAAkC;IAClC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,gCAAgC;AACpC;;AAEA;IACI,YAAY;IACZ,uBAAuB;IACvB,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,qBAAqB;IACrB,UAAU;IACV,6BAA6B;IAC7B,wCAAwC;IACxC,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,YAAY;IACZ,aAAa;IACb,YAAY;IACZ,uBAAuB;IACvB,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,mCAAmC;IACnC,2BAA2B;IAC3B,qBAAqB;IACrB,UAAU;IACV,WAAW;IACX,iBAAiB;IACjB,wBAAwB;IACxB,8BAA8B;IAC9B,4BAA4B;IAC5B,4BAA4B;IAC5B,mBAAmB;IACnB,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,oBAAoB;IACpB,oBAAoB;AACxB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;;4BAE4B;;AAE5B;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,uBAAuB;IACvB,qBAAqB;IACrB,uEAAuE;AAC3E;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;;4BAE4B;;AAE5B;IACI,YAAY;IACZ,SAAS;AACb;;AAEA;IACI,aAAa;AACjB","sourcesContent":["/*  ======================\n    Component styles on page load\n    ====================== */\n\n.mapFilterTrigger {\n    float: left;\n    width: 100%;\n    display: inline-block;\n    padding: 7.5px 10px;\n    height: auto;\n    line-height: 21px;\n    font-size: 14px;\n    color: var(--color-darkui-surface-1);\n    background: var(--color-white);\n    text-decoration: none;\n    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15);\n    border-radius: 4px;\n    box-sizing: border-box;\n}\n\n.mapFilterTrigger:disabled {\n    cursor: default;\n    background: var(--color-lightui-surface-3);\n    color: var(--color-darkui-accent-2);\n}\n\n.mapFilterLabel {\n    float: left;\n    display: inline-block;\n    max-width: 135px;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n}\n\n.mapFilter {\n    width: auto;\n    display: flex;\n    flex-direction: column;\n    container: mapFilter / inline-size;\n    contain: layout;\n}\n\n.mapFilterDetail {\n    position: absolute;\n    display: inline;\n    top: 0%;\n    z-index: -1;\n    width: 100%;\n    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), 0 1px 0 0 var(--color-103);\n    border-radius: 4px;\n    background: var(--color-white);\n    height: 0;\n    padding: 0 10px;\n    overflow: hidden;\n    font-size: 12px;\n    transition: all 0.4s ease;\n    box-sizing: border-box;\n}\n\n.mapFilterDetail ul {\n    margin-left: 5px;\n    list-style-type: none;\n    margin-bottom: 0;\n}\n\n.mapFilterDetail li.sectionDetails {\n    color: black;\n    line-height: 22px;\n    height: 22px;\n}\n\n.mapFilterDetail ul.sectionLabel {\n    color: var(--color-darkui-accent-2);\n}\n\n.mapFilterDetail li.divider {\n    margin: 6px 0;\n    border: 0;\n    background-color: var(--color-103);\n    height: 1px;\n    cursor: initial;\n}\n\n.sectionItemLink {\n    color: var(--color-blue-primary);\n}\n\n.filterCount {\n    padding: 4px;\n    color: var(--color-104);\n    width: 12px;\n    height: 12px;\n    line-height: 12px;\n    text-align: center;\n    border-radius: 12px;\n    display: inline-block;\n    opacity: 1;\n    transition: opacity 0.3s ease;\n    background: var(--color-darkui-accent-2);\n    font-size: 12px;\n    float: right;\n}\n\n.filterOnly {\n    position: relative;\n    top: -25px;\n    float: right;\n    display: none;\n    height: 20px;\n    color: var(--color-201);\n    text-align: right;\n    cursor: pointer;\n    font-size: 12px;\n    text-decoration: none;\n    outline: none;\n}\n\n.iconPointerDown {\n    float: left;\n    margin-top: 3px;\n    margin-right: 5px;\n    font-size: 6px;\n    color: var(--color-darkui-accent-2);\n    transition: width 0.2s ease;\n    display: inline-block;\n    width: 6px;\n    height: 6px;\n    line-height: 14px;\n    vertical-align: text-top;\n    background-position: 14px 14px;\n    background-repeat: no-repeat;\n    font-family: \"connect-icons\";\n    font-weight: normal;\n    font-style: normal;\n    font-variant: normal;\n    speak: none;\n    text-transform: none;\n    text-rendering: auto;\n}\n\n.iconPointerDown:before {\n    content: \"\\25bc\";\n}\n\n.ellipsis{\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\ninput.selectionInput {\n    margin-right: 3px;\n}\n\n/*  ======================\n    Component styles on hover, active, focus, etc.\n    ====================== */\n\n.open .mapFilterTrigger .iconPointerDown,\n.mapFilterTrigger:hover:enabled .iconPointerDown,\n.mapFilterTrigger:active:enabled .iconPointerDown {\n    color: var(--color-102);\n}\n\n.mapFilterTrigger:hover:enabled,\n.mapFilterTrigger:active:enabled,\n.open .mapFilterTrigger {\n    color: var(--color-101);\n    text-decoration: none;\n    box-shadow: inset 0 0 0 1px rgba(0,0,0,.15), 0 1px 0 0 var(--color-103);\n}\n\n.mapFilterDetail li:hover .filterOnly {\n    display: inline;\n}\n\n.sectionItemLink:hover {\n    color: var(--color-blue-primary);\n    text-decoration: underline;\n}\n\n/*  ======================\n    Component styles on state change\n    ====================== */\n\n.open {\n    height: auto;\n    top: 100%;\n}\n\n.open .mapFilterDetail {\n    padding: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mapFilterTrigger": `SelectionDropdown_mapFilterTrigger__+-qEB`,
	"mapFilterLabel": `SelectionDropdown_mapFilterLabel__LQbil`,
	"mapFilter": `SelectionDropdown_mapFilter__iuSYe`,
	"mapFilterDetail": `SelectionDropdown_mapFilterDetail__n5GVg`,
	"sectionDetails": `SelectionDropdown_sectionDetails__Mm2fT`,
	"sectionLabel": `SelectionDropdown_sectionLabel__cDgLv`,
	"divider": `SelectionDropdown_divider__4IOn-`,
	"sectionItemLink": `SelectionDropdown_sectionItemLink__ad69K`,
	"filterCount": `SelectionDropdown_filterCount__gAJKV`,
	"filterOnly": `SelectionDropdown_filterOnly__NCWKh`,
	"iconPointerDown": `SelectionDropdown_iconPointerDown__T56SO`,
	"ellipsis": `SelectionDropdown_ellipsis__Npgwa`,
	"selectionInput": `SelectionDropdown_selectionInput__dh1JK`,
	"open": `SelectionDropdown_open__jJfAD`
};
export default ___CSS_LOADER_EXPORT___;
